"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wishlist = void 0;
require("whatwg-fetch");
var universal_cookie_1 = require("universal-cookie");
var Utils = require("../utils");
var Wishlist = /** @class */ (function () {
    function Wishlist() {
        var _this = this;
        this.context = null;
        this.type = null;
        this.myId = null;
        this.activeId = null;
        this.active = null;
        this.shop = null;
        this.wishlistKey = "theme:wishlist";
        this.cookies = new universal_cookie_1.default();
        this.isCustomerLoggedIn = null;
        this.init = function (context, data, match) {
            _this.context = context;
            _this.shop = data.shop;
            _this.active = match.path === "/apps/toolkit/wishlist/:id";
            _this.isCustomerLoggedIn = data.customer.id ? true : false;
            _this.myId = data.customer
                ? data.customer.id
                : _this.cookies.get("dtk_guest_id");
            _this.activeId =
                _this.active && match.params.id.length ? match.params.id : _this.myId;
            _this.type = data.customer
                ? "Your"
                : _this.activeId === _this.myId
                    ? "Guest"
                    : "Shared";
            _this.getWishlist();
        };
        this.requestURL = function (url) {
            return "" + (window.location.href.includes("localhost")
                ? "https://app.developertoolkit.io/api/client"
                : "/apps/toolkit/client") + url + "?shop=" + _this.shop.domain;
        };
        this.getID = function () { return _this.myId; };
        this.getActiveID = function () { return _this.activeId; };
        this.getType = function () { return _this.type; };
        this.getURL = function () { return "/apps/toolkit/wishlist/" + _this.myId; };
        this.checkActive = function () { return _this.active; };
        this.getWishlist = function () {
            if (!Utils.getLocalStorage(_this.wishlistKey) || (!_this.isCustomerLoggedIn && _this.myId !== JSON.parse(Utils.getLocalStorage(_this.wishlistKey)).customer)) {
                _this.getWishlistJSON();
            }
            else {
                _this.context.update({
                    wishlist: JSON.parse(Utils.getLocalStorage(_this.wishlistKey)),
                    message: "WISHLIST_REQUEST_SUCCESS"
                });
            }
        };
        this.getWishlistJSON = function () {
            try {
                fetch(_this.requestURL("/wishlist/" + _this.activeId + "/json"), {
                    credentials: "same-origin",
                    method: "GET",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache"
                    }
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    Utils.setLocalStorage(_this.wishlistKey, JSON.stringify(data));
                    _this.context.update({
                        wishlist: data,
                        message: "WISHLIST_REQUEST_SUCCESS"
                    });
                });
            }
            catch (err) {
                _this.context.update({
                    message: "WISHLIST_REQUEST_FAILED",
                    error: err.message
                });
            }
        };
        this.toggleItem = function (productId, variantId) {
            _this.checkItem(productId, variantId)
                ? _this.removeItem(productId, variantId)
                : _this.addItem(productId, variantId);
        };
        this.checkItem = function (productId, variantId) {
            var local = Utils.getLocalStorage(_this.wishlistKey);
            var items = JSON.parse(local) ? JSON.parse(local).items : [];
            return items.length
                ? items.filter(function (item) { return parseInt(item.variantId) == variantId; })
                    .length
                : false;
        };
        this.addItem = function (productId, variantId) {
            try {
                fetch(_this.requestURL("/wishlist/" + _this.activeId + "/add/" + productId + ":" + variantId), {
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "Content-Type": "application/json;"
                    }
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    _this.context.update({
                        message: "WISHLIST_ITEM_ADDED_SUCCESS"
                    });
                    _this.getWishlistJSON();
                });
            }
            catch (err) {
                _this.context.update({
                    message: "WISHLIST_ITEM_ADDED_FAILED",
                    error: err.message
                });
            }
        };
        this.removeItem = function (productId, variantId) {
            try {
                fetch(_this.requestURL("/wishlist/" + _this.activeId + "/remove/" + productId + ":" + variantId), {
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "Content-Type": "application/json;"
                    }
                }).then(function (data) {
                    _this.context.update({
                        message: "WISHLIST_ITEM_REMOVED_SUCCESS"
                    });
                    _this.getWishlistJSON();
                });
            }
            catch (err) {
                console.log(err);
                _this.context.update({
                    message: "WISHLIST_ITEM_REMOVED_FAILED",
                    error: err.message
                });
            }
        };
        this.updateItem = function (productId, variantId, newVariantId) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.removeItem(productId, variantId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.addItem(productId, newVariantId)];
                    case 2:
                        _a.sent();
                        this.context.update({
                            message: "WISHLIST_ITEM_UPDATED_SUCCESS"
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.context.update({
                            message: "WISHLIST_ITEM_UPDATED_FAILED",
                            error: err_1.message
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.share = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.requestURL("/wishlist/" + this.activeId + "/share/" + type), {
                                // link, email, sms
                                credentials: "same-origin",
                                method: "POST",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json;"
                                }
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                _this.context.update({
                                    message: "WISHLIST_SHARED_SUCCESS",
                                    wishlistShareURL: _this.shop.url + "/apps/toolkit/wishlist/" + data.id
                                });
                                return data;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/, this.context.update({
                                message: "WISHLIST_SHARED_FAILED",
                                error: err_2.message
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.duplicate = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.requestURL("/wishlist/" + this.activeId + "/duplicate"), {
                                credentials: "same-origin",
                                method: "POST",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json;"
                                }
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                console.log(data);
                                _this.context.update({
                                    message: "WISHLIST_DUPLICATE_SUCCESS"
                                });
                                return data;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_3 = _a.sent();
                        return [2 /*return*/, this.context.update({
                                message: "WISHLIST_DUPLICATE_FAILED",
                                error: err_3.message
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.migrate = function (newId) { return __awaiter(_this, void 0, void 0, function () {
            var err_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.requestURL("/wishlist/" + this.activeId + ":" + newId + "/migrate"), {
                                credentials: "same-origin",
                                method: "POST",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                    "Content-Type": "application/json;"
                                }
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                console.log(data);
                                _this.context.update({
                                    message: "WISHLIST_MIGRATE_SUCCESS"
                                });
                                return data;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_4 = _a.sent();
                        return [2 /*return*/, this.context.update({
                                message: "WISHLIST_MIGRATE_FAILED",
                                error: err_4.message
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    return Wishlist;
}());
exports.Wishlist = Wishlist;
//# sourceMappingURL=wishlist.js.map